import axios from "axios";
import cookieUtils from "@/businesslogic/utils/cookieUtils";
import { TrackingData } from "@/businesslogic/tracking/trackingData";
import { ZusaetzlicheDaten } from "@/businesslogic/tracking/zusaetzlicheDaten";
import { v4 as uuidv4 } from "uuid";
import Logger from "js-logger";
import { Anfrage } from "@/model/Anfrage";
import { Personendaten } from "@/model/Personendaten";
import { Adresse } from "@/model/Adresse";
import { Partner } from "@/model/Partner";
import deepcopy from "deepcopy";

export default function tracking(): any {
  const http = () => {
    const headers = {
      "Content-Type": "application/json",
    };

    return axios.create({
      baseURL: process.env.VUE_APP_TRACKING_BACKEND_URL,
      headers: headers,
    });
  };

  const { getCookie, setCookie } = cookieUtils();

  function anonymisieren(anfrage: Anfrage) {
    const personendaten = new Personendaten();
    const geburtstag = anfrage.personendaten.versicherungsnehmer.geburtsdatum;
    if (geburtstag) {
      personendaten.versicherungsnehmer.geburtsdatum = geburtstag.substring(0, 4) + "-01-01";
    }
    anfrage.personendaten = personendaten;
    anfrage.risikoAnschrift = new Adresse();
    anfrage.zahlungsdaten.iban = "";
    anfrage.zahlungsdaten.kontoinhaberPartner = new Partner();
  }

  function getBenutzerId(): string {
    let vid = getCookie("vid");
    if (!vid) {
      vid = getCookie("Vid"); // Kann nach Anpassung im offenen Bereich und Übergangszeit entfernt werden
    }
    if (!vid) {
      vid = uuidv4();
      setCookie("vid", vid, 30);
    }
    return vid;
  }

  const track = (
    sessionToken: string,
    kontext: string,
    ereignis: string,
    storeData?: Anfrage,
    zusaetzlicheDaten?: ZusaetzlicheDaten,
    alsSeitenkontextMerken = false,
  ) => {
    if (alsSeitenkontextMerken && storeData) {
      storeData.trackingSeitenkontext = kontext;
    }
    if (kontext == "watch" && storeData?.trackingSeitenkontext) {
      kontext = storeData.trackingSeitenkontext;
    }

    const data: TrackingData = {
      sitzung: storeData?.sessionId === undefined ? "" : storeData?.sessionId,
      benutzer: getBenutzerId(),
      kontext: kontext,
      ereignis: ereignis,
      produkt: storeData?.verkaufsprodukt ? storeData.verkaufsprodukt : "unbekannt",
      fachbereich: storeData?.isMakler ? "makler" : "direkt",
      kampagne: getCookie("gevcampagne"),
      kanal: getCookie("gevchannel"),
      partner: getCookie("gev_prtn"),
      parameter: getCookie("gev_prms"),
      referrer: getCookie("gev_ref"),
      landingpage: getCookie("gev_lp"),
      affiliate: getCookie("s_id"),
      antragId: storeData?.antragId ? storeData.antragId : zusaetzlicheDaten?.antragId,
      aussteuerungsgruende: zusaetzlicheDaten?.aussteuerungsgruende,
      fehlergrund: zusaetzlicheDaten?.fehlergrund,
      anfrage: deepcopy(storeData),
    };

    if (data.anfrage !== undefined) {
      anonymisieren(data.anfrage);
    }

    http()
      .post("t/", data, {
        headers: {
          S_Token: sessionToken,
        },
      })
      .catch(() => {
        Logger.warn("auf T konnte nicht zugriffen werden.");
      });
  };

  return {
    track,
  };
}
